import React, { useState, useMemo } from 'react';
import { CaregiverProfile } from '../../../types/index';
import { Card, CardContent, Tabs, Tab, Box } from '@mui/material';
import ProfileSummary from './ProfileSummary';
import AboutTab from './AboutTab';
import ServicesTab from './ServicesTab';
import BadgesTab from './BadgesTab';
import TestimonialsTab from './TestimonialsTab';
import QualificationsTab from './QualificationsTab';

interface ProfileCardProps {
  profile: CaregiverProfile;
}

const TABS = [
  { id: 'about', label: 'About' },
  // { id: 'services', label: 'Skill' },
  { id: 'qualifications', label: 'Qualifications' },
  { id: 'badges', label: 'Badges' },
  // { id: 'testimonials', label: 'Testimonials' }, // TODO: Temporarily hidden - enable when testimonials data is available
];

const ProfileCard: React.FC<ProfileCardProps> = ({ profile }) => {
  const [activeTab, setActiveTab] = useState('about');

  const availableTabs = useMemo(() => {
    return TABS.filter(tab => {
      if (tab.id === 'qualifications') {
        return profile.certs && profile.certs.length > 0;
      }
      return true;
    });
  }, [profile]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'services':
        return <ServicesTab services={profile.services} />;
      case 'qualifications':
        if (!profile.certs || profile.certs.length === 0) return null;
        return <QualificationsTab workExperience={profile.workExperience} certifications={profile.certs} />;
      case 'badges':
        return <BadgesTab badges={profile.badges} />;
      case 'testimonials':
        return <TestimonialsTab testimonials={profile.testimonials} />;
      case 'about':
      default:
        return <AboutTab profile={profile} />;
    }
  };

  return (
    <Card sx={{ borderRadius: 4, boxShadow: '0 8px 32px rgba(0,0,0,0.05)', border: '1px solid #e9ecef' }}>
      <CardContent className="p-0">
        <div className="row g-0">
          <div className="col-lg-4 col-xl-3 border-end-lg border-bottom-under-lg">
            <ProfileSummary profile={profile} />
          </div>

          <div className="col-lg-8 col-xl-9">
            <div className="profile-details-content p-4 p-md-5">
              <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: 3 }}>
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                  aria-label="profile tabs"
                >
                  {availableTabs.map((tab) => (
                    <Tab key={tab.id} label={tab.label} value={tab.id} />
                  ))}
                </Tabs>
              </Box>

              <div>
                {renderTabContent()}
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProfileCard;
